module.exports = __webpack_public_path__ + "static/media/topChampions.3a0dfd92.png";